import {
  SET_SUMMARY,
  SET_IS_FETCHING_DATA,
  SET_EVENTS,
  SET_TODOS,
  SET_IS_FETCHING_TODO,
  SET_MATCHES,
  SET_IS_FETCHING_MATCHES
} from "./mutation-types";
import {
  FETCH_SUMMARY,
  FETCH_EVENTS,
  FETCH_TODOS,
  FETCH_MATCHES,
  UPDATE_MATCH
} from "./action-types";
import api from "@/services/modules/dashboard";
import todosApi from "@/services/modules/todos";
import { handleWithErrorMessage } from "@/services/utils";

const state = {
  clientSummary: [],
  events: [],
  isFetchingData: false,
  todos: [],
  isFetchingTodos: false,
  matches: [],
  isFetchingMatches: false
};

const actions = {
  async [FETCH_SUMMARY]({ commit }, params) {
    try {
      commit(SET_IS_FETCHING_DATA, true);
      const { data } = await api().getAllSummaries(params);
      commit(SET_SUMMARY, data);
      return data;
    } catch (exception) {
      console.error(exception);
    } finally {
      commit(SET_IS_FETCHING_DATA, false);
    }
  },
  async [FETCH_EVENTS]({ commit }, filters) {
    try {
      commit(SET_IS_FETCHING_DATA, true);
      const { data } = await api(commit).getEvents({ filter: filters });
      commit(SET_EVENTS, data);
    } catch (exception) {
      console.error(exception);
    } finally {
      commit(SET_IS_FETCHING_DATA, false);
    }
  },
  async [FETCH_TODOS]({ commit }, userId) {
    try {
      commit(SET_IS_FETCHING_TODO, true);
      const { data } = await todosApi({ commit }).getTodos(userId);
      commit(SET_TODOS, data);
    } catch (exception) {
      console.error(exception);
    } finally {
      commit(SET_IS_FETCHING_TODO, false);
    }
  },
  async [FETCH_MATCHES]({ commit }, userId) {
    try {
      commit(SET_IS_FETCHING_MATCHES, true);
      const { data } = await api({ commit }).getMatches(userId);
      commit(SET_MATCHES, data);
    } catch (exception) {
      console.error(exception);
    } finally {
      commit(SET_IS_FETCHING_MATCHES, false);
    }
  },
  async [UPDATE_MATCH]({ commit, dispatch }, { matchId, data }) {
    return await handleWithErrorMessage({
      request: () =>
        api({ commit }).updateMatch({
          matchId,
          data
        }),
      dispatch
    });
  }
};

const mutations = {
  [SET_IS_FETCHING_DATA](state, isFetching) {
    state.isFetchingData = isFetching;
  },
  [SET_SUMMARY](state, summaries) {
    state.clientSummary = summaries;
  },
  [SET_EVENTS](state, events) {
    state.events = events;
  },
  [SET_TODOS](state, todos) {
    state.todos = todos;
  },
  [SET_IS_FETCHING_TODO](state, isFetching) {
    state.isFetchingTodo = isFetching;
  },
  [SET_MATCHES](state, matches) {
    state.matches = matches;
  },
  [SET_IS_FETCHING_MATCHES](state, isFetching) {
    state.isFetchingMatches = isFetching;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
